import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule, Module } from '@/modules/core/app/constants/app.constants';

export class SalesDashboardRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.isModuleAvailable(AppModule.SALES) &&
      userSettings.hasPermissionToRead(Module.SALES_HEALTH)
    );
  }
}
